import './Library';

jQuery.extend(jQuery.fn.pickadate.defaults, {
    firstDay: 1,
    format: 'd. mmmm yyyy',
    formatSubmit: 'yyyy-mm-dd',
});

if (document.documentElement.lang == 'de') {
    jQuery.extend(jQuery.fn.pickadate.defaults, {
        monthsFull: [
            'Januar',
            'Februar',
            'März',
            'April',
            'Mai',
            'Juni',
            'Juli',
            'August',
            'September',
            'Oktober',
            'November',
            'Dezember',
        ],
        monthsShort: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
        weekdaysFull: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
        weekdaysShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
        today: 'Heute',
        clear: 'Löschen',
        close: 'Schließen',
        labelMonthNext: 'Nächster Monat',
        labelMonthPrev: 'Vorheriger Monat',
        labelMonthSelect: 'Wählen Sie ein Monat',
        labelYearSelect: 'Wählen Sie ein Jahr',
    });
}
